<template>
	<span
		class="d-flex flex-row flex-wrap ml-2"
		v-if="numAdults || numChildren"
		:class="additionalClasses"
	>
		<template v-if="!displayWithIcons">
			<span>
				<span v-if="numAdults" class="numAdults text-capitalize">{{
					numAdults
				}}</span>

				<span v-if="numAdults === 1" class="text-capitalize">
					{{ content.planner_resumeAdult }}</span
				>
				<span v-if="numAdults > 1" class="text-capitalize">
					{{ content.planner_resumeAdults }}</span
				>

				<template v-if="numAdults && numChildren">
					<span>,</span>
					&nbsp;
				</template>
			</span>
			<span>
				<span v-if="numChildren" class="numChildren text-capitalize">{{
					numChildren
				}}</span>

				<span v-if="numChildren === 1" class="text-capitalize">
					{{ content.planner_resumeChild }}</span
				>
				<span v-if="numChildren > 1" class="text-capitalize">
					{{ content.planner_resumeChildren }}</span
				>
			</span>
		</template>
		<template v-else>
			<span>
				<span class="caption text-grey-700 d-flex align-items-center">
					{{ "(" }}
					<span v-if="numAdults">
						<span>{{ numAdults }}</span>
						<svg
							:height="iconSize_adult"
							:width="iconSize_adult"
							class="icon"
							style="margin-bottom: 2px"
						>
							<use xlink:href="#___icon___person"></use>
						</svg>
					</span>
					<span v-if="numChildren">
						{{ "+" }}
						<span>{{ numChildren }}</span>

						<svg :height="iconSize_child" :width="iconSize_child" class="icon">
							<use xlink:href="#___icon___person"></use>
						</svg>
					</span>
					<span
						class="d-block"
						v-if="isServiceToDisplayDuration(optionName) || isCS(variant)"
						>, {{ getServiceDuration(optionName) }} {{ content.days }}
					</span>
					{{ ")" }}
				</span>
			</span>
		</template>
	</span>
</template>

<script>
import iconSizes from "@/config/iconSizes";
import { isServiceToDisplayDuration } from "@/vue/planning/logic/isServiceToDisplayDuration";
import { isCS } from "@/vue/planning/logic/cs";
import getServiceDuration from "@/vue/planning/logic/getServiceDuration";

export default {
	name: "ParticipantsTotals",
	props: {
		participants: {
			type: Array,
			default: () => {
				return [];
			},
		},
		content: {
			type: Object,
			default: () => {
				return {};
			},
		},
		excludedAges: {
			type: Array,
			default: () => {
				return [];
			},
		},
		optionName: {
			type: String,
			default: null,
		},
		variant: {
			type: Object,
			default: null,
		},
		displayWithIcons: {
			type: Boolean,
			default: false,
		},
		additionalClasses: {
			type: String,
			default: "",
		},
	},
	computed: {
		filteredParticipants() {
			return this.participants.filter(
				(age) => !this.excludedAges.includes(age)
			);
		},
		numAdults() {
			return this.filteredParticipants.filter((age) => age >= 18).length;
		},
		numChildren() {
			return this.filteredParticipants.filter((age) => age < 18).length;
		},
		iconSize_adult() {
			return iconSizes.l;
		},
		iconSize_child() {
			return iconSizes.s;
		},
	},

	methods: {
		isCS,
		isServiceToDisplayDuration,
		getServiceDuration,
	},
};
</script>

<style scoped>
.text-capitalize {
	text-transform: capitalize;
}
</style>
